<template>
  <iCallToast
    title="Call sound is off"
    icon="ic:outline-volume-off"
    tone="warning"
    data-test="audio-playback-blocked-notice"
  >
    Your browser won't play call audio until you click. Turn it on to hear everyone.
    <template #actions>
      <iCallToastAction data-test="audio-playback-resume" @click="$emit('resume')">
        Turn on sound
      </iCallToastAction>
    </template>
  </iCallToast>
</template>

<script>
export default {
  name: "AudioPlaybackBlockedNotice",
  emits: ["resume"],
};
</script>
